import type { ReactNode } from 'react';

export const symbol_sports_golf: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M281.5-401.5Q200-483 200-600t81.5-198.5Q363-880 480-880t198.5 81.5Q760-717 760-600t-81.5 198.5Q597-320 480-320t-198.5-81.5ZM636-444q64-64 64-156t-64-156q-64-64-156-64t-156 64q-64 64-64 156t64 156q64 64 156 64t156-64ZM417-623q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm168 0q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm-84-90q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9ZM450-80v-48q0-36-23-59t-59-23h-58q-13 0-21.5-8.5T280-240q0-13 8.5-21.5T310-270h340q13 0 21.5 8.5T680-240q0 13-8.5 21.5T650-210h-58q-36 0-59 23t-23 59v48h-60Zm30-520Z"
		/>
	</svg>
);
